import { render, staticRenderFns } from "./NutriQuest.vue?vue&type=template&id=e32d6074&scoped=true&"
import script from "./NutriQuest.vue?vue&type=script&lang=js&"
export * from "./NutriQuest.vue?vue&type=script&lang=js&"
import style0 from "./NutriQuest.vue?vue&type=style&index=0&id=e32d6074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32d6074",
  null
  
)

export default component.exports